import React from 'react';
import PropTypes from 'prop-types';

import { FIELD_RULES } from '@atlas/react-forms';
import { DateSelect } from '@atlas/ui';

import Field from 'common/Form/Field';

const DaypickerField = ({ field, onBlur, onChange, onFocus }) => {
  const {
    autocomplete,
    disabled,
    errors,
    isModifiable = true,
    label,
    rules,
    touched,
    value,
  } = field;
  const error = touched && errors[0];
  const success = touched && !error;

  const needRule = rules.find(rule => rule.type === FIELD_RULES.MIN_AGE);
  const minAge = needRule ? Number(needRule.ruleOption) : 0;

  return (
    <Field options={field}>
      <DateSelect
        autoComplete={autocomplete}
        disabled={disabled || !isModifiable}
        error={error}
        label={label}
        minValue={minAge}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        success={success}
        value={value}
      />
    </Field>
  );
};

DaypickerField.propTypes = {
  field: PropTypes.shape({
    autocomplete: PropTypes.string,
    disabled: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
    isModifiable: PropTypes.bool,
    label: PropTypes.string,
    rules: PropTypes.arrayOf(
      PropTypes.shape({
        find: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      }),
    ),
    touched: PropTypes.bool,
    value: PropTypes.number,
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default DaypickerField;
